import { apiClient } from '@/shared/api';

import { AiAgentChat, AiAgentChatListResponse, AiAgentMessageListResponse } from './types';

export const createAiAgentChat = async () => {
  const { data } = await apiClient.post<AiAgentChat>('/ai-agent-chat');
  return data;
};

export const fetchAiAgentChats = async (params?: { limit?: number; offset?: number }) => {
  const { data } = await apiClient.get<AiAgentChatListResponse>('/ai-agent-chat', { params });
  return data;
};

export const fetchAiAgentChat = async (id: number) => {
  const { data } = await apiClient.get<AiAgentChat>(`/ai-agent-chat/${id}`);
  return data;
};

export const fetchAiAgentMessages = async (
  chatId: number,
  params?: { limit?: number; offset?: number; sort?: string },
) => {
  const { data } = await apiClient.get<AiAgentMessageListResponse>(`/ai-agent-chat/${chatId}/message`, { params });
  return data;
};
